// Shared by useReportingChatStream's history mapping and buildArtifactSummary's reopen summary —
// both need a follow-up turn to see the actual comparison/value, not just the bare columnId.
const MAX_FILTER_VALUE_LENGTH = 40;
const MAX_FILTER_ENTRIES_PER_GROUP = 3;

export const isRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === "object" && value !== null;

const stringifyFilterValue = (value: unknown): string => {
	const str = JSON.stringify(value) ?? String(value);
	return str.length > MAX_FILTER_VALUE_LENGTH ? `${str.slice(0, MAX_FILTER_VALUE_LENGTH)}…` : str;
};

// filterGroups — an array of OR'd groups, AND'd together (see ArtifactReportFilterEntry).
// `comparison` defaults to equality when omitted, matching translateReportFilters.
// maxEntriesPerGroup — the reopen summary trades completeness for brevity, but chat history must
// keep every entry: nothing downstream can recover a filter value once the turn ages out.
export const describeFilters = (
	filterGroups: unknown,
	maxEntriesPerGroup: number = MAX_FILTER_ENTRIES_PER_GROUP
): string | undefined => {
	if (!Array.isArray(filterGroups) || filterGroups.length === 0) return undefined;
	const groups = filterGroups
		.filter((group): group is unknown[] => Array.isArray(group) && group.length > 0)
		.map((group) => {
			const entries = group.filter(isRecord);
			const shown = entries
				.slice(0, maxEntriesPerGroup)
				.map(
					(entry) =>
						`${String(entry.columnId ?? "")} ${String(entry.comparison ?? "eq")} ${stringifyFilterValue(entry.value)}`
				);
			const remaining = entries.length - shown.length;
			if (remaining > 0) shown.push(`+${remaining} more`);
			return shown.join(" or ");
		})
		.filter((group) => group.length > 0);
	return groups.length > 0 ? `filters: ${groups.join(" and ")}` : undefined;
};

export default describeFilters;
